<script setup>
import Icon from '@/components/shared/icons/Icon.vue'
import TransitionFadeIn from '@/components/shared/transitions/TransitionFadeIn.vue'
import Heading from '@/components/shared/page/Heading.vue'
import {useVisibilityToggle} from '@/composables/use-visibility-toggle.js'
import {useEnv} from '@/composables/use-env.js'
import {ref, onMounted} from 'vue'

//Environment
const {isLocal, isDev, isQa} = useEnv()

//Render after a short delay to allow any page animations to complete first
const isRendered = ref(false)
onMounted(() => setTimeout(() => isRendered.value = true, 500))

//Visibility toggle
const devToolsPanel = ref(null)
const devToolsToggle = ref(null)
const {
  isVisible,
  toggle,
} = useVisibilityToggle(devToolsPanel, devToolsToggle)
</script>

<template>
  <TransitionFadeIn>
    <div
      v-if="(isLocal || isDev || isQa) && isRendered"
      :class="{
        [$style.wrapper]: true,
        [$style.open]: isVisible,
      }"
    >
      <div
        ref="devToolsToggle"
        test-id="devToolsToggle"
        :class="$style.trigger"
        @click="toggle()"
      >
        <Icon
          icon="auto_fix_high"
          size="s"
        />
      </div>
      <Heading
        size="s"
        :class="$style.header"
        text="Dev tools"
      />
      <div
        ref="devToolsPanel"
        :class="$style.content"
        alignment="right"
      >
        <slot />
      </div>
    </div>
  </TransitionFadeIn>
</template>

<style module lang="scss">
.wrapper {
  position: fixed;
  top: 70px;
  right: -300px;
  padding: 0.5rem;
  padding-right: 0;
  width: 300px;
  transition: all var(--transition-cubic);
  background: var(--color-primary);
  border-radius: 0 0 0 var(--border-radius-m);
  &.open {
    right: 0;
    box-shadow: 0 0 20px rgba(0,0,0,0.2);
    .trigger {
      &:hover {
        background: var(--color-primary);
        box-shadow: none;
      }
    }
  }
}
.trigger {
  position: absolute;
  top: 0;
  left: -40px;
  padding: 1rem;
  padding-right: 0.25rem;
  border-radius: 40px 0 0 40px;
  color: var(--color-white);
  transition: all var(--transition-cubic-fast);
  cursor: pointer;
  background: var(--color-primary);
  &:hover {
    background: var(--color-primary-hover);
    box-shadow: var(--box-shadow-strong);
  }
}
.header {
  margin: 0 !important;
  height: 36px;
  line-height: 36px;
  color: var(--color-white);
}
.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  margin-top: 0.5rem;
  padding: 1rem;
  background: var(--color-white);
  border-radius: var(--border-radius-m) 0 0 var(--border-radius-m);
}
</style>
